const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px !important",
    // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px !important", // Adjust label position when it shrinks
  },
  // padding: "7px",
};

const errorFieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px", // Adjust label position when it shrinks
  },
  borderBottom: "1px solid red",
};

const prefer_tax_term = [
  { value: "contract", label: "Contract" },
  { value: "contract_to_hire", label: "Contract To Hire" },
  { value: "full_Time", label: "Fulltime" },
  { value: "w2_with_benefit", label: "W2 Hourly Benefit" },
  { value: "w2_without_benefit", label: "W2 Hourly No Benefit" },
  { value: "1099", label: "1099" },
  // { value: "working_in_all", label: "All" },
];

const prefer_tax_term1 = [
  { value: "contract", label: "Contract" },
  { value: "contract_to_hire", label: "Contract To Hire" },
  { value: "full_Time", label: "Fulltime" },
  { value: "w2_with_benefit", label: "W2 Hourly Benefit" },
  { value: "w2_without_benefit", label: "W2 Hourly No Benefit" },
  { value: "1099", label: "1099" },
];

const gender = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Others", label: "Others" },
];

const time_zone_choices = [
  {
    value: "PST",
    label: "PST ",
  },
  {
    value: "MST",
    label: "MST ",
  },
  {
    value: "EST",
    label: "EST ",
  },
  {
    value: "CST",
    label: "CST ",
  },
];

const work_preference = [
  {
    value: "Remote",
    label: "Remote ",
  },
  {
    value: "Onsite",
    label: "Onsite",
  },
  {
    value: "Hybrid",
    label: "Hybrid",
  },
  // {
  //   value: "All",
  //   label: "All ",
  // },
];

const work_preference1 = [
  {
    value: "Remote",
    label: "Remote ",
  },
  {
    value: "Onsite",
    label: "Onsite",
  },
  {
    value: "Hybrid",
    label: "Hybrid",
  },
];

const mode_of_interview = [
  {
    value: "Phone",
    label: "Phone ",
  },
  {
    value: "Virtual",
    label: "Virtual",
  },
  {
    value: "In Person",
    label: "In Person",
  },
];

const priority = [
  {
    value: "fromrecent",
    label: "From Recent",
  },
  {
    value: "frompast",
    label: "From Past",
  },
];

const WORK_AUTHORIZATIONS = [
  {
    id: "GC",
    name: "GC",
  },
  {
    id: "USC",
    name: "USC",
  },
  {
    id: "UPT",
    name: "UPT",
  },
];

export {
  fieldStyle,
  errorFieldStyle,
  prefer_tax_term,
  gender,
  work_preference,
  time_zone_choices,
  mode_of_interview,
  priority,
  WORK_AUTHORIZATIONS,
  prefer_tax_term1,
  work_preference1,
};
